<comment-form [shopingCart]="shopingCart" [textHedaer]="'Califica a nuestro repartidor'" #commentForm (commentFor)="OnSubmit($event)"></comment-form>